const cityNames = [
  'Leiderdorp',
  'Waalre',
  'Wijk-bij-Duurstede',
  'Tholen',
  'Culemborg',
  'Zaltbommel',
  'Hendrik-Ido-Ambacht',
  'Amersfoort',
];
export default cityNames.map(city => city.toLocaleLowerCase());
